import React, { useState, useEffect } from "react";
import Code from "./coding/Code";
import { getPDF, get2fa } from "../api/api";
import ResponseDialog from "./dialog/ResponseDialog";
import { QRCodeSVG } from 'qrcode.react';

const Home = () => {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [resmessage, setResmessage] = useState("");
    const [typemessage, setTypemessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [qrCode, setQrCode] = useState("");
    const [token, setToken] = useState("");
    const [appname, setAppname] = useState("");
    const [username, setUsername] = useState("");

    const formdata = {
        email,
        name
    };

    function MyQRCode(uri) {
        return <QRCodeSVG value={uri} size={166} />;
    }

    const generatePDF = async () => {
        setIsLoading(true);
        setTypemessage("info");
        setResmessage("Generating PDF...");
        try {
            const response = await getPDF(formdata);
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: "application/pdf" });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank"); // Apre il PDF in una nuova scheda
                setTypemessage("success");
                setResmessage("PDF generated successfully");
            } else {
                setTypemessage("error");
                setResmessage("Error generating PDF");
            }
        } catch (error) {
            setTypemessage("error");
            setResmessage("Error communicating with the server.");
        }
        setIsLoading(false);
    };

    useEffect(() => {
        const fetch2fa = async () => {
            try {
                console.log("Fetching 2FA data...");
                const response = await get2fa(appname, username);
                if (response.status === 200) {
                    setQrCode(response.data.newSecret.uri);
                    setToken(response.data.newSecret.secret);
                } else {
                    setTypemessage("error");
                    setResmessage("Error fetching 2FA data");
                }
            } catch (error) {
                setTypemessage("error");
                setResmessage("Error communicating with the 2fa server.");
            }
        }
        fetch2fa();
    }, [appname, username]);

    return (
        <div className="card">
            <div className="card-header">
                <h5>Home</h5>
            </div>
            <div className="card-body">
                {MyQRCode(qrCode)}

                <form>
                    <div className="row">
                        <div className="form-group col-md-6 mb-3">
                            <label htmlFor="appname">App name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="appname"
                                value={appname}
                                onChange={(e) => setAppname(e.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-6 mb-3">
                            <label htmlFor="username">Username</label>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                    </div>
                </form>

                {token && <p>{token}</p>}
                {typemessage && resmessage && <ResponseDialog type={typemessage} message={resmessage} onClose={() => setResmessage("")} />}
                <div id="content-id">
                    <h4>CLIENT</h4>
                    <ul className="list-group mb-5">
                        <li className="list-group-item">1.Vai nella cartella dei progetti</li>
                        <li className="list-group-item">2.Esegui il comando <Code>npm uninstall -g create-react-app</Code></li>
                        <li className="list-group-item">3.Esegui il comando <Code>npx create-react-app my-app</Code></li>
                        <li className="list-group-item">4.Crea il file .env con all'interno "PORT=[port_number]" per scegliere la porta del progetto (importante per node.js)</li>
                        <li className="list-group-item">5.Esegui il comando <Code>npm start</Code> nella cartella del progetto appena creata</li>
                    </ul>

                    <h4>SERVER</h4>
                    <ul className="list-group mb-5">
                        <li className="list-group-item">1.Esegui il comando <Code>npm run build</Code> all'interno della cartella del progetto per compilare la build</li>
                        <li className="list-group-item">2.Esegui il comando <Code>pm2 serve build [port] --name [name] --spa</Code> dentro la cartella del progetto per installare l'app in pm2</li>
                        <li className="list-group-item">3.Esegui il comando <Code>pm2 save</Code> per salvare</li>
                    </ul>

                    <h4>NODE.JS</h4>
                    <ul className="list-group mb-5">
                        <li className="list-group-item">1.Esegui il comando <Code>pm2 start app.js --name [name]</Code> dentro la cartella del progetto per installare l'app in pm2</li>
                        <li className="list-group-item">2.Esegui il comando <Code>pm2 save</Code> per salvare</li>
                    </ul>
                </div>

                {isLoading ? (
                    <button className="btn btn-danger" type="button" disabled>
                        <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                        Loading...
                    </button>
                ) : (
                    <button className="btn btn-danger" onClick={() => generatePDF()}>Generate PDF</button>
                )}
            </div>
        </div>
    );
};
export default Home;